// rulerManager.js
let instance = null;

export function registerRuler(ref) {
  instance = ref;
}

export function toggleRuler() {
  if (instance) {
    instance.toggle();
  }
}

export function toggleRulerReset() {
  if (instance) {
    instance.toggleReset();
  }
}